// import React, { useEffect, useState } from 'react';
// import {
//   Box,
//   Paper,
//   Avatar,
//   Typography,
//   TextField,
//   Button,
//   Grid,
//   Divider,
//   IconButton,
//   InputAdornment,
//   Alert,
//   CircularProgress,
// } from '@mui/material';
// import EditIcon from '@mui/icons-material/Edit';
// import CloseIcon from '@mui/icons-material/Close';
// import Visibility from '@mui/icons-material/Visibility';
// import VisibilityOff from '@mui/icons-material/VisibilityOff';
// import SaveIcon from '@mui/icons-material/Save';
// import { getMyProfile, updateStaffCredentials } from '../../../services/adminService'; // path apne project ke hisaab se adjust karo

// const BRAND_COLOR = '#0D2D62';

// const ProfilePage = () => {
//   const [profile, setProfile] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [editMode, setEditMode] = useState(false);
//   const [saving, setSaving] = useState(false);

//   const [newEmail, setNewEmail] = useState('');
//   const [newPassword, setNewPassword] = useState('');
//   const [confirmPassword, setConfirmPassword] = useState('');
//   const [showPassword, setShowPassword] = useState(false);

//   const [successMsg, setSuccessMsg] = useState('');
//   const [errorMsg, setErrorMsg] = useState('');

//   // Profile fetch karo mount pe
//   const fetchProfile = async () => {
//     setLoading(true);
//     try {
//       const res = await getMyProfile();
//       setProfile(res.data);
//       setNewEmail(res.data?.email || '');
//     } catch (error) {
//       setErrorMsg('Profile load nahi hui. Dobara try karo.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchProfile();
//   }, []);

//   const handleEditToggle = () => {
//     setErrorMsg('');
//     setSuccessMsg('');
//     if (editMode) {
//       // Cancel kiya to reset kar do
//       setNewEmail(profile?.email || '');
//       setNewPassword('');
//       setConfirmPassword('');
//     }
//     setEditMode(!editMode);
//   };

//   const handleSave = async () => {
//     setErrorMsg('');
//     setSuccessMsg('');

//     // Basic validation
//     if (newPassword && newPassword.length < 5) {
//       setErrorMsg('Password kam se kam 5 characters ka hona chahiye.');
//       return;
//     }
//     if (newPassword && newPassword !== confirmPassword) {
//       setErrorMsg('Password aur Confirm Password match nahi kar rahe.');
//       return;
//     }
//     if (!newEmail && !newPassword) {
//       setErrorMsg('Kuch to change karo — email ya password.');
//       return;
//     }

//     setSaving(true);
//     try {
//       const payload = { userId: profile._id };
//       if (newEmail && newEmail !== profile.email) payload.newEmail = newEmail;
//       if (newPassword) payload.newPassword = newPassword;

//       const res = await updateStaffCredentials(payload);

//       setSuccessMsg(res.message || 'Profile update ho gayi!');
//       setNewPassword('');
//       setConfirmPassword('');
//       setEditMode(false);
//       // Profile dubara fetch karlo latest data ke liye
//       fetchProfile();
//     } catch (error) {
//       setErrorMsg(error.response?.data?.message || 'Update fail ho gaya. Dobara try karo.');
//     } finally {
//       setSaving(false);
//     }
//   };

//   if (loading) {
//     return (
//       <Box sx={{ display: 'flex', justifyContent: 'center', mt: 10 }}>
//         <CircularProgress sx={{ color: BRAND_COLOR }} />
//       </Box>
//     );
//   }

//   return (
//     <Box sx={{ maxWidth: 600, mx: 'auto', mt: 5, px: 2 }}>
//       <Paper elevation={3} sx={{ borderRadius: 3, overflow: 'hidden' }}>
//         {/* Header */}
//         <Box
//           sx={{
//             bgcolor: BRAND_COLOR,
//             color: '#fff',
//             py: 4,
//             display: 'flex',
//             flexDirection: 'column',
//             alignItems: 'center',
//           }}
//         >
//           <Avatar
//             sx={{
//               width: 90,
//               height: 90,
//               bgcolor: '#dcf2fd',
//               color: BRAND_COLOR,
//               fontSize: 32,
//               fontWeight: 'bold',
//               border: '3px solid #fff',
//             }}
//           >
//             {profile?.name?.charAt(0)?.toUpperCase() || 'U'}
//           </Avatar>
//           <Typography variant="h6" sx={{ mt: 2, fontWeight: 'bold' }}>
//             {profile?.name}
//           </Typography>
//           <Typography variant="body2" sx={{ opacity: 0.85, textTransform: 'capitalize' }}>
//             {profile?.role}
//           </Typography>
//         </Box>

//         {/* Body */}
//         <Box sx={{ p: 3 }}>
//           {successMsg && (
//             <Alert severity="success" sx={{ mb: 2 }}>
//               {successMsg}
//             </Alert>
//           )}
//           {errorMsg && (
//             <Alert severity="error" sx={{ mb: 2 }}>
//               {errorMsg}
//             </Alert>
//           )}

//           <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
//             <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: BRAND_COLOR }}>
//               Account Details
//             </Typography>
//             <IconButton onClick={handleEditToggle} sx={{ color: BRAND_COLOR }}>
//               {editMode ? <CloseIcon /> : <EditIcon />}
//             </IconButton>
//           </Grid>

//           <Divider sx={{ mb: 3 }} />

//           {!editMode ? (
//             <>
//               <ProfileRow label="Email" value={profile?.email} />
//               <ProfileRow label="Country" value={profile?.country?.name || '—'} />
//               <ProfileRow label="State" value={profile?.state?.name || '—'} />
//               <ProfileRow label="City" value={profile?.city?.name || '—'} />
//             </>
//           ) : (
//             <Box component="form" noValidate autoComplete="off">
//               <TextField
//                 fullWidth
//                 label="Email"
//                 type="email"
//                 value={newEmail}
//                 onChange={(e) => setNewEmail(e.target.value)}
//                 sx={{ mb: 2 }}
//               />

//               <TextField
//                 fullWidth
//                 label="New Password"
//                 type={showPassword ? 'text' : 'password'}
//                 value={newPassword}
//                 onChange={(e) => setNewPassword(e.target.value)}
//                 placeholder="Blank chodo agar password change nahi karna"
//                 sx={{ mb: 2 }}
//                 InputProps={{
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
//                         {showPassword ? <VisibilityOff /> : <Visibility />}
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//               />

//               {newPassword && (
//                 <TextField
//                   fullWidth
//                   label="Confirm New Password"
//                   type={showPassword ? 'text' : 'password'}
//                   value={confirmPassword}
//                   onChange={(e) => setConfirmPassword(e.target.value)}
//                   sx={{ mb: 2 }}
//                 />
//               )}

//               <Button
//                 fullWidth
//                 variant="contained"
//                 startIcon={<SaveIcon />}
//                 onClick={handleSave}
//                 disabled={saving}
//                 sx={{
//                   bgcolor: BRAND_COLOR,
//                   '&:hover': { bgcolor: '#0a2350' },
//                   py: 1.2,
//                 }}
//               >
//                 {saving ? 'Saving...' : 'Save Changes'}
//               </Button>
//             </Box>
//           )}
//         </Box>
//       </Paper>
//     </Box>
//   );
// };

// // Chhota helper component - read-only row dikhane ke liye
// const ProfileRow = ({ label, value }) => (
//   <Grid container sx={{ mb: 1.5 }}>
//     <Grid item xs={4}>
//       <Typography variant="body2" color="text.secondary">
//         {label}
//       </Typography>
//     </Grid>
//     <Grid item xs={8}>
//       <Typography variant="body2" sx={{ fontWeight: 500 }}>
//         {value || '—'}
//       </Typography>
//     </Grid>
//   </Grid>
// );

// export default ProfilePage;

import React, { useEffect, useState } from 'react';
import {
  Box,
  Paper,
  Avatar,
  Typography,
  TextField,
  Button,
  Grid,
  Divider,
  IconButton,
  InputAdornment,
  Alert,
  CircularProgress,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import SaveIcon from '@mui/icons-material/Save';
import { getMyProfile, updateStaffCredentials } from '../../../services/adminService'; 

const BRAND_COLOR = '#6aa7af';

const ProfilePage = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [saving, setSaving] = useState(false);

  const [newEmail, setNewEmail] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');

  const fetchProfile = async () => {
    setLoading(true);
    try {
      const res = await getMyProfile();
      // Yahan res.data aapka wahi JSON hoga jo aapne provide kiya hai
      setProfile(res.data);
      setNewEmail(res.data?.email || '');
    } catch (error) {
      setErrorMsg('Profile load nahi hui. Dobara try karo.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  const handleEditToggle = () => {
    setErrorMsg('');
    setSuccessMsg('');
    if (editMode) {
      setNewEmail(profile?.email || '');
      setNewPassword('');
      setConfirmPassword('');
    }
    setEditMode(!editMode);
  };

  const handleSave = async () => {
    setErrorMsg('');
    setSuccessMsg('');

    if (newPassword && newPassword.length < 5) {
      setErrorMsg('Password kam se kam 5 characters ka hona chahiye.');
      return;
    }
    if (newPassword && newPassword !== confirmPassword) {
      setErrorMsg('Password aur Confirm Password match nahi kar rahe.');
      return;
    }

    setSaving(true);
    try {
      const payload = { userId: profile._id };
      if (newEmail && newEmail !== profile.email) payload.newEmail = newEmail;
      if (newPassword) payload.newPassword = newPassword;

      const res = await updateStaffCredentials(payload);

      setSuccessMsg(res.message || 'Profile update ho gayi!');
      setNewPassword('');
      setConfirmPassword('');
      setEditMode(false);
      fetchProfile();
    } catch (error) {
      setErrorMsg(error.response?.data?.message || 'Update fail ho gaya.');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 10 }}>
        <CircularProgress sx={{ color: BRAND_COLOR }} />
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', mt: 5, px: 2, pb: 5 }}>
      <Paper elevation={4} sx={{ borderRadius: 4, overflow: 'hidden' }}>
        {/* Header Section with Profile Image */}
        <Box
          sx={{
            bgcolor: BRAND_COLOR,
            color: '#fff',
            py: 5,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            position: 'relative'
          }}
        >
          <Avatar
            src={profile?.profileImage} // Aapka DigitalOcean wala link yahan use hoga
            alt={profile?.name}
            sx={{
              width: 110,
              height: 110,
              bgcolor: '#fff',
              color: BRAND_COLOR,
              fontSize: 40,
              fontWeight: 'bold',
              border: '4px solid rgba(255,255,255,0.3)',
              boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
            }}
          >
            {/* Agar image nahi load hui to first letter dikhega */}
            {profile?.name?.charAt(0)?.toUpperCase()}
          </Avatar>
          
          <Typography variant="h5" sx={{ mt: 2, fontWeight: '600', letterSpacing: 0.5 }}>
            {profile?.name || 'Admin User'}
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.8, textTransform: 'uppercase', mt: 0.5, fontWeight: 'bold' }}>
            {profile?.role}
          </Typography>
        </Box>

        {/* Body Section */}
        <Box sx={{ p: 4 }}>
          {successMsg && <Alert severity="success" sx={{ mb: 3 }}>{successMsg}</Alert>}
          {errorMsg && <Alert severity="error" sx={{ mb: 3 }}>{errorMsg}</Alert>}

          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
            <Typography variant="h6" sx={{ fontWeight: 'bold', color: BRAND_COLOR }}>
              Account Settings
            </Typography>
            <IconButton 
              onClick={handleEditToggle} 
              sx={{ 
                bgcolor: editMode ? '#fee2e2' : '#f0f4ff', 
                color: editMode ? '#dc2626' : BRAND_COLOR,
                '&:hover': { bgcolor: editMode ? '#fecaca' : '#e0e7ff' }
              }}
            >
              {editMode ? <CloseIcon /> : <EditIcon fontSize="small" />}
            </IconButton>
          </Box>
          
          <Divider sx={{ mb: 3 }} />

          {!editMode ? (
            <Grid container spacing={2}>
              <ProfileRow label="Full Name" value={profile?.name} />
              <ProfileRow label="Email Address" value={profile?.email} />
              <ProfileRow label="Current Role" value={profile?.role} />
              {/* Optional: Agar location data ho to */}
             
            </Grid>
          ) : (
            <Box component="form">
              <TextField
                fullWidth
                label="Email Address"
                variant="outlined"
                value={newEmail}
                onChange={(e) => setNewEmail(e.target.value)}
                sx={{ mb: 2.5 }}
              />

              <TextField
                fullWidth
                label="New Password"
                type={showPassword ? 'text' : 'password'}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Leave blank to keep current password"
                sx={{ mb: 2.5 }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              {newPassword && (
                <TextField
                  fullWidth
                  label="Confirm New Password"
                  type={showPassword ? 'text' : 'password'}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  sx={{ mb: 3 }}
                />
              )}

              <Button
                fullWidth
                variant="contained"
                startIcon={saving ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />}
                onClick={handleSave}
                disabled={saving}
                sx={{
                  bgcolor: BRAND_COLOR,
                  '&:hover': { bgcolor: '#0a2350' },
                  py: 1.5,
                  borderRadius: 2,
                  fontWeight: 'bold',
                  textTransform: 'none',
                  fontSize: '1rem'
                }}
              >
                {saving ? 'Updating...' : 'Save Changes'}
              </Button>
            </Box>
          )}
        </Box>
      </Paper>
    </Box>
  );
};

// Helper component for info rows
const ProfileRow = ({ label, value }) => (
  <Grid item xs={12} sx={{ display: 'flex', py: 1 }}>
    <Typography variant="body2" sx={{ width: '140px', color: 'text.secondary', fontWeight: 500 }}>
      {label}
    </Typography>
    <Typography variant="body1" sx={{ fontWeight: 600, color: '#333' }}>
      {value || '—'}
    </Typography>
  </Grid>
);

export default ProfilePage;